import { createFileRoute } from "@tanstack/react-router";
import { permanentRedirect } from "@/lib/routeRedirect";

// Legacy URL: Partner Accounts now lives at /admin/partner-accounts.
export const Route = createFileRoute("/_admin/admin/partners")({
  beforeLoad: permanentRedirect("/admin/partner-accounts"),
});
